import type {
  ChartRealtimePayload,
  TradingViewSubscription,
} from 'types/TradingViewSubscription';

import { useTradingViewStoreBase } from '../tradingView/tradingView.store';

const setTradingViewSubscriptionData = (payload: TradingViewSubscription) => {
  useTradingViewStoreBase.getState().actions.setTradingViewSubscriptionData(payload);
};

const updateTradingViewData = (data: ChartRealtimePayload) => {
  useTradingViewStoreBase.getState().actions.updateTradingViewData(data);
};

export { setTradingViewSubscriptionData, updateTradingViewData };
